import { createSelector } from '@ngrx/store';

import { travelerAdapter } from '@pax/store/reducers/travelers.reducer';
import { paxRootSelector } from '@pax/store/selectors/pax-root.selector';
import { PaxState } from '@pax/store/state/pax.state';

const { selectAll } = travelerAdapter.getSelectors();

const getTravelerPaxState = 
    createSelector(paxRootSelector, (state: PaxState) => state ? state.travelers : travelerAdapter.getInitialState());

export const selectTravelerPaxState = createSelector(getTravelerPaxState, selectAll);
